import { ipeso, creavicash, maxcredito, kabilcash, xcredito, xfectivo, tifi, credifio, creditaco } from './mx';
import { kashway, ipesa, creditmoja, tifiKe, tifiSlice } from './ke';
import { xcredit, credit9ja, mocash, mocashMx, naira9ja } from './ng';
import { ucredit, mangucash, isente } from './ug';
import { isolez } from './peru';
import { champloan } from './es';
import { parcecredit } from './pa';
import { getQueryVariable } from '@/utils/utils';

export default {
  kashway,
  ipesa,
  creditmoja: creditmoja('creditmoja'),
  tifislice: tifiSlice('tifislice'),
  xcredit: xcredit('XCREDIT'),
  imoney: xcredit('Imoney'),
  credit9ja,
  naira9ja,
  ucredit,
  isente,
  mangucash,
  ipeso,
  creavicash,
  maxcredito,
  tifi: tifi,
  'tifi-ke': tifiKe,
  kabilcash,
  xfectivo: xfectivo,
  icredito: xcredito,
  xcredito: xcredito,
  creditaco,
  isolez: isolez(),
  caja: isolez('C Platinka'),
  credifio,
  mocash: getQueryVariable('lang') === 'mx' ? mocashMx : mocash,
  champloan,
  parcecredit: parcecredit('ParceCredit'),
  'credifio-co': parcecredit('Credifio'),
}